import './SliderTrack.1413e98b1deea7b836f228de36b07fa9.css';
export default {"track":"_track_5r0lr_1"};